"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventRegItem = void 0;
const RegDto_1 = require("../dto/RegDto");
const FormFieldValue_1 = require("./FormFieldValue");
class EventRegItem {
    constructor() {
        this.id = 0;
        this.state = RegDto_1.EventRegItemStateDto.SUBMITTED;
        this.email = "";
        this.firstName = "";
        this.lastName = "";
        this.formFieldValues = [];
        this.created = 0;
        this.updated = 0;
    }
    static fromDto(dto) {
        const result = new EventRegItem();
        result.id = dto.id;
        result.state = dto.state;
        result.email = dto.required.email;
        result.firstName = dto.required.name.first;
        result.lastName = dto.required.name.last;
        result.formFieldValues = dto.custom.map(dto => FormFieldValue_1.FormFieldValue.fromDto(dto));
        result.created = dto.created;
        result.updated = dto.updated;
        return result;
    }
    toDto() {
        return {
            id: this.id,
            state: this.state,
            required: {
                email: this.email,
                name: {
                    first: this.firstName,
                    last: this.lastName,
                },
            },
            custom: this.formFieldValues.map(formFieldValue => formFieldValue.toDto()),
            created: this.created,
            updated: this.updated,
        };
    }
    copy() {
        const copy = new EventRegItem();
        copy.id = this.id;
        copy.state = this.state;
        copy.email = this.email;
        copy.firstName = this.firstName;
        copy.lastName = this.lastName;
        copy.formFieldValues = this.formFieldValues.map(formFieldValue => formFieldValue.copy());
        copy.created = this.created;
        copy.updated = this.updated;
        return copy;
    }
}
exports.EventRegItem = EventRegItem;
